import React from "react";
import { NavLink, Link } from "react-router-dom";
import "../../styles/banner.css";

export default function Banner(props) {
  return (
    <div className="banner-container">
      <Link className="my-name" to={"/"}>
        <div>
          <h1>
            <span className="red">J</span>onah&nbsp;
            <span className="red">T</span>
            illman
          </h1>
        </div>
      </Link>
      <div className="nav-bar">
        <nav>
          <NavLink
            to="/my-work"
            exact={true}
            className={({ isActive }) =>
              "nav-link" + (isActive ? " activated" : "")
            }
          >
            My Work
          </NavLink>
          <NavLink
            exact={true}
            className={({ isActive }) =>
              "nav-link" + (isActive ? " activated" : "")
            }
            to="/who-i-am"
          >
            {" "}
            Who I am
          </NavLink>

          <a
            href="jonah-tillman-resume.pdf"
            className="resume"
            download={"jonah-tillman-resume"}
          >
            Resume ⇣
          </a>
        </nav>
      </div>
    </div>
  );
}
